import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { CrashReportApi } from "../../../../../../../../../../../../../../../services/Api/Admin/adminTypes";

interface Props {
	crashReport: CrashReportApi;
	handleCloseCrashReport: () => void;
	handleRestoreCrashReport: () => void;
	handleStartFixingCrashReport: () => void;
	setShowMarkAsPermanentlyBrokenModal: (value: boolean) => void;
}

const CrashReportButtons = ({
	crashReport,
	handleCloseCrashReport,
	handleStartFixingCrashReport,
	handleRestoreCrashReport,
	setShowMarkAsPermanentlyBrokenModal,
}: Props) => {
	const { t } = useTranslation("admin");

	return (
		<>
			{crashReport.status !== "ARCHIVED" && (
				<Button variant="light" onClick={handleCloseCrashReport}>
					{t("common.action.close", { ns: "lib" })}
				</Button>
			)}
			{crashReport.status !== "OCCURRING" && (
				<Button variant="light" onClick={handleRestoreCrashReport}>
					{t("common.action.restore", { ns: "lib" })}
				</Button>
			)}
			{crashReport.status !== "ARCHIVED" && crashReport.status !== "WORK_IN_PROGRESS" && (
				<Button variant="light" onClick={handleStartFixingCrashReport}>
					{t("modules.crash_report.action.start_fix.title")}
				</Button>
			)}
			{crashReport.status !== "PERMANENTLY_BROKEN" && (
				<Button variant="light" onClick={() => setShowMarkAsPermanentlyBrokenModal(true)}>
					{t("modules.crash_report.action.mark_as_permanently_broken.title")}
				</Button>
			)}
		</>
	);
};

export default CrashReportButtons;
